import { useSelector } from 'react-redux';
const useAuth = () => {
  const auth = useSelector(state => state.auth.isAuthenticated);
  const user = useSelector(state => state.auth.user);
  const token = useSelector(state => state.auth.token);
  const isLoading=useSelector(state=> state.auth.isLoading)
  

  return { isAuthenticated:auth,  loading:isLoading, token, user  };
};

export default useAuth;